"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quebecCities = void 0;
exports.quebecCities = [
    {
        label: "Abercorn",
        value: 1006,
    },
    {
        label: "Abitibi",
        value: 1027,
    },
    {
        label: "Actonvale",
        value: 1008,
    },
    {
        label: "Adamsville",
        value: 1010,
    },
    {
        label: "Adstock",
        value: 1021,
    },
    {
        label: "Ahuntsic",
        value: 1604,
    },
    {
        label: "Albanel",
        value: 1012,
    },
    {
        label: "Alma, QC",
        value: 1014,
    },
    {
        label: "A-Ma-Baie",
        value: 1602,
    },
    {
        label: "Amos",
        value: 1016,
    },
    {
        label: "Amqui",
        value: 1018,
    },
    {
        label: "Andreville",
        value: 1022,
    },
    {
        label: "Angers",
        value: 1028,
    },
    {
        label: "Anjou",
        value: 1029,
    },
    {
        label: "Annaville",
        value: 1030,
    },
    {
        label: "Armagh",
        value: 1032,
    },
    {
        label: "Arthabaska",
        value: 1034,
    },
    {
        label: "Arvida",
        value: 1036,
    },
    {
        label: "Asbestos",
        value: 1038,
    },
    {
        label: "Ascot Corner",
        value: 1039,
    },
    {
        label: "Aston Jonction",
        value: 1040,
    },
    {
        label: "Athelston",
        value: 1041,
    },
    {
        label: "Ayer's Cliff",
        value: 1042,
    },
    {
        label: "Aylmer, QC",
        value: 1044,
    },
    {
        label: "Bagotville",
        value: 1050,
    },
    {
        label: "Baie de Shawiniga",
        value: 1056,
    },
    {
        label: "Baie-Comeau",
        value: 1052,
    },
    {
        label: "Baie-des-Sables",
        value: 1054,
    },
    {
        label: "Baie-du-Febvre",
        value: 1057,
    },
    {
        label: "Baie-du-Poste",
        value: 1053,
    },
    {
        label: "Baie-d'UrfÃ©",
        value: 1606,
    },
    {
        label: "Baie-Saint-Paul",
        value: 1058,
    },
    {
        label: "Baie-Trinite",
        value: 1060,
    },
    {
        label: "Baieville",
        value: 1062,
    },
    {
        label: "Barkmere",
        value: 1064,
    },
    {
        label: "Barraute",
        value: 1066,
    },
    {
        label: "Barville",
        value: 1068,
    },
    {
        label: "Beaconsfield, QC",
        value: 1608,
    },
    {
        label: "Beattyville",
        value: 1070,
    },
    {
        label: "Beauce",
        value: 1189,
    },
    {
        label: "Beauceville",
        value: 1072,
    },
    {
        label: "Beauharnois",
        value: 1074,
    },
    {
        label: "Beaulac",
        value: 1076,
    },
    {
        label: "Beaulieu",
        value: 1078,
    },
    {
        label: "Beauport",
        value: 2032,
    },
    {
        label: "Beaupre",
        value: 1082,
    },
    {
        label: "Beaurepaire",
        value: 1610,
    },
    {
        label: "Becancour",
        value: 1084,
    },
    {
        label: "Bedford, QC",
        value: 1086,
    },
    {
        label: "Beebe Plain",
        value: 1088,
    },
    {
        label: "Belair",
        value: 1090,
    },
    {
        label: "Bellefeuille",
        value: 1091,
    },
    {
        label: "Belleterre",
        value: 1092,
    },
    {
        label: "Beloeil",
        value: 1094,
    },
    {
        label: "Bernieres",
        value: 1095,
    },
    {
        label: "Bernierville",
        value: 1096,
    },
    {
        label: "Berthierville",
        value: 1098,
    },
    {
        label: "Bishopton",
        value: 1102,
    },
    {
        label: "Black Lake",
        value: 1104,
    },
    {
        label: "Blainville",
        value: 1106,
    },
    {
        label: "Boileau",
        value: 1597,
    },
    {
        label: "Boisbriand",
        value: 1107,
    },
    {
        label: "Boisbuard",
        value: 1105,
    },
    {
        label: "Boischatel",
        value: 1109,
    },
    {
        label: "Bois-des-Filion",
        value: 1108,
    },
    {
        label: "Bolton-Ouest",
        value: 1153,
    },
    {
        label: "Bonaventure",
        value: 1111,
    },
    {
        label: "Boucherville",
        value: 1110,
    },
    {
        label: "Brebeuf",
        value: 1043,
    },
    {
        label: "Brigham",
        value: 1119,
    },
    {
        label: "Brome",
        value: 1112,
    },
    {
        label: "Bromont",
        value: 1114,
    },
    {
        label: "Bromptonville",
        value: 1116,
    },
    {
        label: "Brossard",
        value: 1612,
    },
    {
        label: "Brownsburg",
        value: 1120,
    },
    {
        label: "Bryson",
        value: 1122,
    },
    {
        label: "Buckingham",
        value: 1124,
    },
    {
        label: "Cabano",
        value: 1130,
    },
    {
        label: "Cadillac, QC",
        value: 1132,
    },
    {
        label: "Calixa-Lavallee",
        value: 1045,
    },
    {
        label: "Calumet",
        value: 1134,
    },
    {
        label: "Campbell's Bay",
        value: 1136,
    },
    {
        label: "Candiac",
        value: 1616,
    },
    {
        label: "Cantley",
        value: 1138,
    },
    {
        label: "Cap-a-l'Aigle",
        value: 1140,
    },
    {
        label: "Cap-aux-Meules",
        value: 1142,
    },
    {
        label: "Cap-Chat",
        value: 1144,
    },
    {
        label: "Cap-de-la-Madeleine",
        value: 1146,
    },
    {
        label: "Caplan",
        value: 1046,
    },
    {
        label: "Cap-Rouge",
        value: 1147,
    },
    {
        label: "Cap-SantÃ©",
        value: 1587,
    },
    {
        label: "Carignan",
        value: 1148,
    },
    {
        label: "Carillon",
        value: 1150,
    },
    {
        label: "Carleton",
        value: 1151,
    },
    {
        label: "Cartierville",
        value: 1618,
    },
    {
        label: "Causapscal",
        value: 1152,
    },
    {
        label: "Chambly",
        value: 1154,
    },
    {
        label: "Chambord",
        value: 1156,
    },
    {
        label: "Champlain",
        value: 1158,
    },
    {
        label: "Chandler",
        value: 1160,
    },
    {
        label: "Chapais",
        value: 1162,
    },
    {
        label: "Chapeau",
        value: 1164,
    },
    {
        label: "Charlemagne",
        value: 1118,
    },
    {
        label: "Charlesbourg, QC",
        value: 2034,
    },
    {
        label: "Charny",
        value: 1170,
    },
    {
        label: "Chateauguay",
        value: 1174,
    },
    {
        label: "Chateauguay Centre",
        value: 1176,
    },
    {
        label: "Chateau-Richer",
        value: 1172,
    },
    {
        label: "Chelsea",
        value: 1177,
    },
    {
        label: "Cheneville",
        value: 1178,
    },
    {
        label: "Chertsey, QC",
        value: 1007,
    },
    {
        label: "Chesterville, QC",
        value: 1180,
    },
    {
        label: "Chibougamau",
        value: 1182,
    },
    {
        label: "Chicoutimi",
        value: 1184,
    },
    {
        label: "Chicoutimi Nord",
        value: 1186,
    },
    {
        label: "Chisasibi",
        value: 1187,
    },
    {
        label: "Chomedy",
        value: 1622,
    },
    {
        label: "Chute-aux-Outardes",
        value: 1188,
    },
    {
        label: "Clarenceville",
        value: 1190,
    },
    {
        label: "Clermont",
        value: 1192,
    },
    {
        label: "Clova",
        value: 1193,
    },
    {
        label: "Coaticook",
        value: 1194,
    },
    {
        label: "Compton",
        value: 1196,
    },
    {
        label: "Contrecoeur",
        value: 1198,
    },
    {
        label: "Cookshire",
        value: 1200,
    },
    {
        label: "Coteau-du-Lac",
        value: 1202,
    },
    {
        label: "Coteau-Landing",
        value: 1204,
    },
    {
        label: "Cote-des-Neiges",
        value: 1025,
    },
    {
        label: "CÃ´te-Sainte-Catherine",
        value: 1630,
    },
    {
        label: "CÃ´te-Saint-Luc",
        value: 1628,
    },
    {
        label: "Courcelles",
        value: 1205,
    },
    {
        label: "Courville",
        value: 1206,
    },
    {
        label: "Cowansville",
        value: 1208,
    },
    {
        label: "Crabtree",
        value: 1210,
    },
    {
        label: "Dalesville",
        value: 1218,
    },
    {
        label: "Danville",
        value: 1220,
    },
    {
        label: "Daveluyville",
        value: 1222,
    },
    {
        label: "De Grasse",
        value: 1224,
    },
    {
        label: "Deauville",
        value: 1226,
    },
    {
        label: "Degelis",
        value: 1228,
    },
    {
        label: "Delson",
        value: 1634,
    },
    {
        label: "Desbiens",
        value: 1232,
    },
    {
        label: "Deschaillons",
        value: 1234,
    },
    {
        label: "Deschaillons-sur-Saint-Laurent",
        value: 1236,
    },
    {
        label: "Deschambault",
        value: 1238,
    },
    {
        label: "Deschenes",
        value: 1240,
    },
    {
        label: "Deux-Montagnes",
        value: 1242,
    },
    {
        label: "Disraeli",
        value: 1244,
    },
    {
        label: "Dixville",
        value: 1246,
    },
    {
        label: "Dolbeau",
        value: 1248,
    },
    {
        label: "Dollard-des-Ormeaux",
        value: 1636,
    },
    {
        label: "Donnaconna",
        value: 1252,
    },
    {
        label: "Dorion",
        value: 1254,
    },
    {
        label: "Dorval",
        value: 1638,
    },
    {
        label: "Dosquet",
        value: 1256,
    },
    {
        label: "Douville",
        value: 1258,
    },
    {
        label: "Drummondville",
        value: 1260,
    },
    {
        label: "Duberger",
        value: 1261,
    },
    {
        label: "Duclos",
        value: 1125,
    },
    {
        label: "Dunham",
        value: 1262,
    },
    {
        label: "Duparquet",
        value: 1264,
    },
    {
        label: "Durham South, QC",
        value: 1266,
    },
    {
        label: "Duvernay",
        value: 1640,
    },
    {
        label: "East Angus",
        value: 1270,
    },
    {
        label: "East Broughton St",
        value: 1272,
    },
    {
        label: "East Farnham",
        value: 1274,
    },
    {
        label: "East Hereford",
        value: 1275,
    },
    {
        label: "Eastman",
        value: 1276,
    },
    {
        label: "Esterel",
        value: 1278,
    },
    {
        label: "Evain",
        value: 1280,
    },
    {
        label: "Fabre",
        value: 1286,
    },
    {
        label: "Fabreville",
        value: 1288,
    },
    {
        label: "Farnham",
        value: 1290,
    },
    {
        label: "Ferme-Neuve",
        value: 1292,
    },
    {
        label: "Fermont",
        value: 1291,
    },
    {
        label: "Filford",
        value: 1293,
    },
    {
        label: "Fleurmont",
        value: 1295,
    },
    {
        label: "Forestville",
        value: 1294,
    },
    {
        label: "Fort-Coulonge",
        value: 1296,
    },
    {
        label: "Fortierville",
        value: 1298,
    },
    {
        label: "Fossambault-sur-le-Lac",
        value: 1300,
    },
    {
        label: "Foster",
        value: 1301,
    },
    {
        label: "Francoeur",
        value: 1302,
    },
    {
        label: "Franklin",
        value: 1303,
    },
    {
        label: "Frelighsburg",
        value: 1304,
    },
    {
        label: "Gagnon",
        value: 1310,
    },
    {
        label: "Gaspe",
        value: 1312,
    },
    {
        label: "Gatineau",
        value: 1314,
    },
    {
        label: "Gentilly",
        value: 1315,
    },
    {
        label: "Giffard",
        value: 1316,
    },
    {
        label: "Girardville",
        value: 1047,
    },
    {
        label: "Glenn Sutton",
        value: 1317,
    },
    {
        label: "Godbout",
        value: 1318,
    },
    {
        label: "Godmanchester",
        value: 1126,
    },
    {
        label: "Gracefield",
        value: 1320,
    },
    {
        label: "Granby",
        value: 1322,
    },
    {
        label: "Grande-Ile",
        value: 1323,
    },
    {
        label: "Grandes-Bergeronnes",
        value: 1326,
    },
    {
        label: "Grande-VallÃ©e",
        value: 1325,
    },
    {
        label: "Grand-MÃ¨re",
        value: 1324,
    },
    {
        label: "Greece's Point",
        value: 1328,
    },
    {
        label: "Greenfield Park",
        value: 1646,
    },
    {
        label: "Grenville",
        value: 1330,
    },
    {
        label: "Ham Nord",
        value: 1336,
    },
    {
        label: "Hampstead",
        value: 1648,
    },
    {
        label: "Hatley",
        value: 1340,
    },
    {
        label: "Hauterive",
        value: 1342,
    },
    {
        label: "Hebertville Stati",
        value: 1344,
    },
    {
        label: "Hemmingford",
        value: 1346,
    },
    {
        label: "Henryville",
        value: 1348,
    },
    {
        label: "Howick",
        value: 1350,
    },
    {
        label: "Hudson",
        value: 1352,
    },
    {
        label: "Hudson Heights",
        value: 1353,
    },
    {
        label: "Hull",
        value: 1354,
    },
    {
        label: "Huntingdon, QC",
        value: 1356,
    },
    {
        label: "Iberville",
        value: 1360,
    },
    {
        label: "Ãle Charron",
        value: 1650,
    },
    {
        label: "Ãle Claude",
        value: 1652,
    },
    {
        label: "Ãle Dorval",
        value: 1658,
    },
    {
        label: "Ãle Laval",
        value: 1660,
    },
    {
        label: "Ãle-aux-Coudres",
        value: 1361,
    },
    {
        label: "Ãle-Bizard",
        value: 1364,
    },
    {
        label: "Ãle-Cadieux",
        value: 1362,
    },
    {
        label: "Ãle-de-la-Visitation",
        value: 1654,
    },
    {
        label: "Ãle-des-Soeurs",
        value: 1656,
    },
    {
        label: "Ãle-d'Orlea",
        value: 1363,
    },
    {
        label: "Ãle-Michon",
        value: 1365,
    },
    {
        label: "Ãle-Perrot",
        value: 1366,
    },
    {
        label: "Ãles-de-la-Madeleine",
        value: 1367,
    },
    {
        label: "Ãles-d'Entree",
        value: 1368,
    },
    {
        label: "Inverness, QC",
        value: 1370,
    },
    {
        label: "Jacques-Cartier",
        value: 1626,
    },
    {
        label: "Joliette",
        value: 1380,
    },
    {
        label: "JonquiÃ¨re",
        value: 1382,
    },
    {
        label: "Joutel",
        value: 1384,
    },
    {
        label: "Kahnawake",
        value: 1620,
    },
    {
        label: "Kamouraska",
        value: 1386,
    },
    {
        label: "Kenogami",
        value: 1388,
    },
    {
        label: "Kingsbury",
        value: 1390,
    },
    {
        label: "Kingsey Falls",
        value: 1392,
    },
    {
        label: "Kinnear",
        value: 1387,
    },
    {
        label: "Kirkland",
        value: 1664,
    },
    {
        label: "Knowlton",
        value: 1393,
    },
    {
        label: "La Baie",
        value: 2497,
    },
    {
        label: "La Guadeloupe",
        value: 1408,
    },
    {
        label: "La Macaza",
        value: 1585,
    },
    {
        label: "La Malbaie",
        value: 1410,
    },
    {
        label: "La Patrie",
        value: 1412,
    },
    {
        label: "La Peche",
        value: 1049,
    },
    {
        label: "La Perade",
        value: 1414,
    },
    {
        label: "La Plaine",
        value: 1415,
    },
    {
        label: "La PocatiÃ¨re",
        value: 1416,
    },
    {
        label: "La Prairie",
        value: 1670,
    },
    {
        label: "La PrÃ©sentation",
        value: 1418,
    },
    {
        label: "La Providence",
        value: 1420,
    },
    {
        label: "La Reine",
        value: 1422,
    },
    {
        label: "La Sarre",
        value: 1424,
    },
    {
        label: "La Station du Cot",
        value: 1426,
    },
    {
        label: "La Tuque",
        value: 1428,
    },
    {
        label: "La Visitation",
        value: 1429,
    },
    {
        label: "Labelle",
        value: 1430,
    },
    {
        label: "L'Acadie",
        value: 1394,
    },
    {
        label: "Lac-Ã -la-Croix",
        value: 1432,
    },
    {
        label: "Lac-au-Saumon",
        value: 1434,
    },
    {
        label: "Lac-Beauport",
        value: 1435,
    },
    {
        label: "Lac-Bouchette",
        value: 1436,
    },
    {
        label: "Lac-Brome",
        value: 1438,
    },
    {
        label: "Lac-Carre",
        value: 1440,
    },
    {
        label: "Lac-Delage",
        value: 1442,
    },
    {
        label: "Lac-des-Ãcorces",
        value: 1444,
    },
    {
        label: "Lac-Etchemin",
        value: 1446,
    },
    {
        label: "Lachenaie",
        value: 1456,
    },
    {
        label: "Lachine",
        value: 1672,
    },
    {
        label: "Lachute",
        value: 1458,
    },
    {
        label: "Lac-Masson",
        value: 1447,
    },
    {
        label: "Lac-Megantic",
        value: 1448,
    },
    {
        label: "Lacolle",
        value: 1460,
    },
    {
        label: "Lac-Poulin",
        value: 1450,
    },
    {
        label: "Lac-Saint-Charles",
        value: 1451,
    },
    {
        label: "Lac-Sainte-Marie",
        value: 1051,
    },
    {
        label: "Lac-Saint-Jean",
        value: 1453,
    },
    {
        label: "Lac-Saint-Joseph",
        value: 1454,
    },
    {
        label: "Lac-Saint-Paul",
        value: 1455,
    },
    {
        label: "Lac-Sergent",
        value: 1452,
    },
    {
        label: "Lac-SupÃ©rieur",
        value: 1457,
    },
    {
        label: "LaflÃ¨che, QC",
        value: 1674,
    },
    {
        label: "Lafontaine",
        value: 1464,
    },
    {
        label: "Lambton",
        value: 1466,
    },
    {
        label: "L'Ancienne-Lorette",
        value: 1020,
    },
    {
        label: "L'Ange-Gardien",
        value: 1024,
    },
    {
        label: "Langeliers",
        value: 1026,
    },
    {
        label: "L'Annonciation",
        value: 1396,
    },
    {
        label: "L'Anse-Saint-Jean",
        value: 1048,
    },
    {
        label: "LaSalle",
        value: 1676,
    },
    {
        label: "Lasavanne",
        value: 1468,
    },
    {
        label: "L'Assomption",
        value: 1398,
    },
    {
        label: "LaterriÃ¨re",
        value: 1470,
    },
    {
        label: "Laurentides",
        value: 1472,
    },
    {
        label: "Laurier Station",
        value: 1474,
    },
    {
        label: "Laurierville",
        value: 1476,
    },
    {
        label: "Lauzon",
        value: 1478,
    },
    {
        label: "Laval",
        value: 1678,
    },
    {
        label: "Laval-des-Rapides",
        value: 1480,
    },
    {
        label: "Lavaltrie",
        value: 1482,
    },
    {
        label: "L'Avenir",
        value: 1400,
    },
    {
        label: "Lawrenceville",
        value: 1484,
    },
    {
        label: "Le Bic",
        value: 1100,
    },
    {
        label: "Le Gardeur",
        value: 1489,
    },
    {
        label: "Lebel-sur-QuÃ©villon",
        value: 1486,
    },
    {
        label: "Leclercville",
        value: 1488,
    },
    {
        label: "Lemieux",
        value: 1490,
    },
    {
        label: "Lemoyne",
        value: 1680,
    },
    {
        label: "Lennoxville",
        value: 1492,
    },
    {
        label: "L'Ãpiphanie",
        value: 1402,
    },
    {
        label: "Lery",
        value: 1494,
    },
    {
        label: "Les Becquets",
        value: 1496,
    },
    {
        label: "Les CÃ¨dres",
        value: 1498,
    },
    {
        label: "LÃ©vis",
        value: 1500,
    },
    {
        label: "Limoilou",
        value: 1501,
    },
    {
        label: "Liniere",
        value: 1502,
    },
    {
        label: "L'Isle Verte",
        value: 1406,
    },
    {
        label: "L'Islet",
        value: 1404,
    },
    {
        label: "Longue-Pointe",
        value: 1682,
    },
    {
        label: "Longueuil",
        value: 1684,
    },
    {
        label: "Loretteville",
        value: 2036,
    },
    {
        label: "Lorraine",
        value: 1506,
    },
    {
        label: "Lorrainville",
        value: 1508,
    },
    {
        label: "LotbiniÃ¨re",
        value: 1510,
    },
    {
        label: "Louiseville",
        value: 1512,
    },
    {
        label: "Luceville",
        value: 1514,
    },
    {
        label: "Luskville",
        value: 1516,
    },
    {
        label: "Lyster",
        value: 1518,
    },
    {
        label: "Macamic",
        value: 1530,
    },
    {
        label: "Magog",
        value: 1532,
    },
    {
        label: "Malartic",
        value: 1534,
    },
    {
        label: "Malbaie",
        value: 1535,
    },
    {
        label: "Maniwaki",
        value: 1536,
    },
    {
        label: "Manseau",
        value: 1538,
    },
    {
        label: "Mansonville",
        value: 1539,
    },
    {
        label: "Maple Grove",
        value: 1540,
    },
    {
        label: "Marbleton",
        value: 1542,
    },
    {
        label: "Maria",
        value: 1055,
    },
    {
        label: "Marieville",
        value: 1544,
    },
    {
        label: "Marsoui",
        value: 1546,
    },
    {
        label: "Mascouche",
        value: 1548,
    },
    {
        label: "Maskinonge",
        value: 1550,
    },
    {
        label: "Masson",
        value: 1552,
    },
    {
        label: "Massueville",
        value: 1554,
    },
    {
        label: "Matagami",
        value: 1556,
    },
    {
        label: "Matane",
        value: 1558,
    },
    {
        label: "McMasterville",
        value: 1560,
    },
    {
        label: "Melbourne",
        value: 1562,
    },
    {
        label: "Melocheville",
        value: 1564,
    },
    {
        label: "Mercier",
        value: 1566,
    },
    {
        label: "Metabetchouan",
        value: 1567,
    },
    {
        label: "MÃ©tis-sur-Mer",
        value: 1568,
    },
    {
        label: "Mirabel",
        value: 1573,
    },
    {
        label: "Mistassini",
        value: 1570,
    },
    {
        label: "Moffet",
        value: 1569,
    },
    {
        label: "Mont Laurier",
        value: 1576,
    },
    {
        label: "Mont Saint-Pierre",
        value: 1580,
    },
    {
        label: "Mont-Apica",
        value: 1571,
    },
    {
        label: "Montauban",
        value: 1582,
    },
    {
        label: "Mont-Carmel",
        value: 1575,
    },
    {
        label: "Montcerf",
        value: 1583,
    },
    {
        label: "Montebello",
        value: 1584,
    },
    {
        label: "Mont-Gabriel",
        value: 1572,
    },
    {
        label: "Mont-Joli",
        value: 1574,
    },
    {
        label: "Montmagny",
        value: 1586,
    },
    {
        label: "Montmorency",
        value: 1588,
    },
    {
        label: "Montreal",
        value: 1694,
    },
    {
        label: "Montreal Centre-Nord",
        value: 1692,
    },
    {
        label: "Montreal Est",
        value: 1696,
    },
    {
        label: "Montreal Nord",
        value: 1698,
    },
    {
        label: "Montreal Nord-Est",
        value: 1700,
    },
    {
        label: "Montreal Nord-Ouest",
        value: 1702,
    },
    {
        label: "Montreal Ouest",
        value: 1708,
    },
    {
        label: "Montreal Sud-Est",
        value: 1710,
    },
    {
        label: "Mont-Rolland",
        value: 1577,
    },
    {
        label: "Mont-Royal",
        value: 1716,
    },
    {
        label: "Mont-Saint-Gregoire",
        value: 1579,
    },
    {
        label: "Mont-Saint-Hilaire",
        value: 1578,
    },
    {
        label: "Mont-Tremblant",
        value: 1581,
    },
    {
        label: "Morin-Heights",
        value: 1590,
    },
    {
        label: "Murdochville",
        value: 1908,
    },
    {
        label: "Napierville",
        value: 1928,
    },
    {
        label: "NeufchÃ¢tel",
        value: 1929,
    },
    {
        label: "Neuville",
        value: 1930,
    },
    {
        label: "New Carlisle",
        value: 2772,
    },
    {
        label: "New Glasgow, QC",
        value: 1932,
    },
    {
        label: "New Richmond",
        value: 1934,
    },
    {
        label: "Nicolet",
        value: 1936,
    },
    {
        label: "Nitro",
        value: 1937,
    },
    {
        label: "Nominingue",
        value: 1938,
    },
    {
        label: "Noranda",
        value: 1940,
    },
    {
        label: "Norbertville",
        value: 1942,
    },
    {
        label: "Normandin",
        value: 1944,
    },
    {
        label: "North Hatley",
        value: 1946,
    },
    {
        label: "Notre-Dame-de-Bon-Secours",
        value: 1718,
    },
    {
        label: "Notre-Dame-de-Grace",
        value: 1720,
    },
    {
        label: "Notre-Dame-de-Ãle-Perrot",
        value: 1719,
    },
    {
        label: "Notre-Dame-de-Pierreville",
        value: 1919,
    },
    {
        label: "Notre-Dame-des-Anges",
        value: 1922,
    },
    {
        label: "Notre-Dame-des-Laurentides",
        value: 2038,
    },
    {
        label: "Notre-Dame-des-Pins",
        value: 1721,
    },
    {
        label: "Notre-Dame-des-Prairies",
        value: 1923,
    },
    {
        label: "Notre-Dame-d'Hebertville",
        value: 1920,
    },
    {
        label: "Notre-Dame-du-Bon-Conseil",
        value: 1924,
    },
    {
        label: "Notre-Dame-du-Lac",
        value: 1926,
    },
    {
        label: "Notre-Dame-du-SacrÃ©-Coeur",
        value: 1722,
    },
    {
        label: "Noyan",
        value: 1947,
    },
    {
        label: "Oka",
        value: 1948,
    },
    {
        label: "Omerville",
        value: 1952,
    },
    {
        label: "Orford",
        value: 1953,
    },
    {
        label: "Ormstown",
        value: 1954,
    },
    {
        label: "Orsainville",
        value: 2040,
    },
    {
        label: "Other",
        value: 2999,
    },
    {
        label: "Otterburn Park",
        value: 1958,
    },
    {
        label: "Outremont",
        value: 1730,
    },
    {
        label: "Packington",
        value: 1059,
    },
    {
        label: "Pagenteuil",
        value: 1736,
    },
    {
        label: "Papineauville",
        value: 1970,
    },
    {
        label: "Parent",
        value: 1972,
    },
    {
        label: "Pascalis",
        value: 1974,
    },
    {
        label: "Paspebiac",
        value: 1975,
    },
    {
        label: "Pentecote",
        value: 1737,
    },
    {
        label: "PercÃ©",
        value: 1976,
    },
    {
        label: "Perkins",
        value: 1738,
    },
    {
        label: "Petite-Riviere-Saint-Francois",
        value: 1127,
    },
    {
        label: "Petit-Saguenay",
        value: 1598,
    },
    {
        label: "Philipsburg",
        value: 1978,
    },
    {
        label: "Piedmont",
        value: 1979,
    },
    {
        label: "Pierrefonds Est",
        value: 1740,
    },
    {
        label: "Pierrefonds Ouest",
        value: 1742,
    },
    {
        label: "Pierreville",
        value: 1980,
    },
    {
        label: "Pincourt",
        value: 1982,
    },
    {
        label: "Pintendre",
        value: 1743,
    },
    {
        label: "Plessisville",
        value: 1984,
    },
    {
        label: "Pohenegamook",
        value: 1061,
    },
    {
        label: "Point-au-PÃ¨re",
        value: 1985,
    },
    {
        label: "Pointe-au-Pic",
        value: 1986,
    },
    {
        label: "Pointe-aux-Outardes",
        value: 1988,
    },
    {
        label: "Pointe-aux-Trembles",
        value: 1746,
    },
    {
        label: "Pointe-Calumet",
        value: 1992,
    },
    {
        label: "Pointe-Claire",
        value: 1748,
    },
    {
        label: "Pointe-des-Cascades",
        value: 1996,
    },
    {
        label: "Pointe-du-Moulin",
        value: 1998,
    },
    {
        label: "Pointe-Fortune",
        value: 2002,
    },
    {
        label: "Pointe-Gatineau",
        value: 2004,
    },
    {
        label: "Pointe-Lebel",
        value: 2006,
    },
    {
        label: "Pont-Rouge",
        value: 2008,
    },
    {
        label: "Pont-Viau",
        value: 1750,
    },
    {
        label: "Portage-du-Fort",
        value: 2014,
    },
    {
        label: "Port-Alfred",
        value: 2010,
    },
    {
        label: "Port-Cartier",
        value: 2012,
    },
    {
        label: "Portneuf",
        value: 2016,
    },
    {
        label: "Povungnituk",
        value: 2017,
    },
    {
        label: "Preissac",
        value: 1063,
    },
    {
        label: "Preville",
        value: 1754,
    },
    {
        label: "Prevost",
        value: 2018,
    },
    {
        label: "Price",
        value: 2020,
    },
    {
        label: "Princeville",
        value: 2022,
    },
    {
        label: "Proulxville",
        value: 2024,
    },
    {
        label: "Quebec City",
        value: 2030,
    },
    {
        label: "Quyon",
        value: 2060,
    },
    {
        label: "Radisson, QC",
        value: 2068,
    },
    {
        label: "Rawdon",
        value: 2070,
    },
    {
        label: "Repentigny",
        value: 2072,
    },
    {
        label: "Richelieu",
        value: 2074,
    },
    {
        label: "Richmond, QC",
        value: 2078,
    },
    {
        label: "Rigaud",
        value: 2080,
    },
    {
        label: "Rimouski",
        value: 2082,
    },
    {
        label: "Rimouski Est",
        value: 2084,
    },
    {
        label: "Ripon",
        value: 2086,
    },
    {
        label: "RiviÃ¨re-Beaudette",
        value: 2088,
    },
    {
        label: "RiviÃ¨re-des-Prairies",
        value: 1760,
    },
    {
        label: "RiviÃ¨re-du-Loup",
        value: 2090,
    },
    {
        label: "RiviÃ¨re-du-Moulin",
        value: 2092,
    },
    {
        label: "Riviere-Malbaie",
        value: 2093,
    },
    {
        label: "Robertsonville",
        value: 2094,
    },
    {
        label: "Roberval",
        value: 2096,
    },
    {
        label: "Rock Island",
        value: 2098,
    },
    {
        label: "Rock-Forest",
        value: 2097,
    },
    {
        label: "Rosemere",
        value: 2100,
    },
    {
        label: "Rosemont",
        value: 1128,
    },
    {
        label: "Rougemont",
        value: 2102,
    },
    {
        label: "Rouyn",
        value: 2104,
    },
    {
        label: "Roxboro",
        value: 1762,
    },
    {
        label: "Roxton Falls",
        value: 2108,
    },
    {
        label: "Roxton Pond",
        value: 1763,
    },
    {
        label: "S.Bernard-Lacolle",
        value: 1065,
    },
    {
        label: "Sabrevois",
        value: 2109,
    },
    {
        label: "SacrÃ©-Coeur-de-Jesus",
        value: 2110,
    },
    {
        label: "Saguenay",
        value: 2112,
    },
    {
        label: "Saint-Adolphe-d'Howard",
        value: 1243,
    },
    {
        label: "Saint-Anaclet-de-Lessard",
        value: 1765,
    },
    {
        label: "Saint-Andre-Avellin",
        value: 2156,
    },
    {
        label: "Saint-Andre-d'Acton",
        value: 2157,
    },
    {
        label: "Saint-Andre-du-Lac-Saint-Jean",
        value: 2158,
    },
    {
        label: "Saint-Antoine-de-Tilly",
        value: 2163,
    },
    {
        label: "Saint-Basile-le-Grand",
        value: 2166,
    },
    {
        label: "Saint-Boniface-de-Shawinigan",
        value: 2172,
    },
    {
        label: "Saint-Bruno-de-Montarville",
        value: 2176,
    },
    {
        label: "Saint-Charles-Borromee",
        value: 1009,
    },
    {
        label: "Saint-Charles-des-Grondines",
        value: 2188,
    },
    {
        label: "Saint-Charles-sur-Richelieu",
        value: 2190,
    },
    {
        label: "Saint-Coeur-de-Marie",
        value: 2196,
    },
    {
        label: "Saint-Come",
        value: 1129,
    },
    {
        label: "Saint-David-de-L'Auberiviere",
        value: 2202,
    },
    {
        label: "Sainte-Anne-de-BeauprÃ©",
        value: 2386,
    },
    {
        label: "Sainte-Anne-de-Bellevue",
        value: 1770,
    },
    {
        label: "Sainte-CÃ©cile-de-Levrard",
        value: 2404,
    },
    {
        label: "Sainte-CÃ©cile-de-Masham",
        value: 2405,
    },
    {
        label: "Sainte-CÃ©cile-de-Milton",
        value: 2399,
    },
    {
        label: "Sainte-Claire",
        value: 1771,
    },
    {
        label: "Sainte-DorothÃ©e",
        value: 2401,
    },
    {
        label: "Sainte-Emelie-de-L'Energie",
        value: 1019,
    },
    {
        label: "Sainte-FelicitÃ©",
        value: 2402,
    },
    {
        label: "Sainte-Foy",
        value: 2042,
    },
    {
        label: "Sainte-Genevieve",
        value: 1772,
    },
    {
        label: "Sainte-Genevieve-de-Batiscan",
        value: 1773,
    },
    {
        label: "Sainte-HÃ©lÃ¨ne-de-Bagot",
        value: 2408,
    },
    {
        label: "Sainte-Jeanne-d'Arc",
        value: 2410,
    },
    {
        label: "Sainte-Julie",
        value: 2411,
    },
    {
        label: "Saint-Elie-d'Orford",
        value: 1774,
    },
    {
        label: "Sainte-Marcelline-de-Kildare",
        value: 1145,
    },
    {
        label: "Sainte-Marguerite-Esterel",
        value: 1137,
    },
    {
        label: "Sainte-Marie-Beauce",
        value: 1775,
    },
    {
        label: "Sainte-Marthe-sur-le-Lac",
        value: 2419,
    },
    {
        label: "Sainte-MÃ©lanie",
        value: 2423,
    },
    {
        label: "Saint-Ephrem-De-Tring",
        value: 2212,
    },
    {
        label: "Sainte-Scholastique",
        value: 2426,
    },
    {
        label: "Sainte-Sophie",
        value: 1776,
    },
    {
        label: "Sainte-Sophie-de-Levrard",
        value: 2428,
    },
    {
        label: "Saint-Esprit",
        value: 1069,
    },
    {
        label: "Sainte-ThÃ©rÃ¨se Ouest",
        value: 2432,
    },
    {
        label: "Saint-Etienne-de-Lauzon",
        value: 1777,
    },
    {
        label: "Saint-Felix-de-Valois",
        value: 2218,
    },
    {
        label: "Saint-Ferreol-les-Neiges",
        value: 1011,
    },
    {
        label: "Saint-Gedeon",
        value: 2114,
    },
    {
        label: "Saint-Georges-de-Beauce",
        value: 2231,
    },
    {
        label: "Saint-Georges-de-Cacouna",
        value: 2232,
    },
    {
        label: "Saint-Georges-de-Windsor",
        value: 2234,
    },
    {
        label: "Saint-Georges-Ouest",
        value: 2236,
    },
    {
        label: "Saint-Germain-de-Grantham",
        value: 2240,
    },
    {
        label: "Saint-Gregoire",
        value: 2242,
    },
    {
        label: "Saint-Gregoire-de-Greenlay",
        value: 2244,
    },
    {
        label: "Saint-HermÃ©nÃ©gilde",
        value: 2250,
    },
    {
        label: "Saint-Hilarion",
        value: 1135,
    },
    {
        label: "Saint-HonorÃ©",
        value: 2252,
    },
    {
        label: "Saint-Jean",
        value: 2264,
    },
    {
        label: "Saint-Jean-Baptiste-de-Nicolet",
        value: 2266,
    },
    {
        label: "Saint-Jean-Chrysostome",
        value: 2268,
    },
    {
        label: "Saint-Jean-de-Boischatel",
        value: 2270,
    },
    {
        label: "Saint-Jean-de-Dieu",
        value: 2771,
    },
    {
        label: "Saint-Jean-de-Matha",
        value: 2271,
    },
    {
        label: "Saint-Jean-Port-Joli",
        value: 1778,
    },
    {
        label: "Saint-Jean-sur-le-Richelieu",
        value: 2269,
    },
    {
        label: "Saint-Jean-Vianney",
        value: 2272,
    },
    {
        label: "Saint-Jerome",
        value: 2274,
    },
    {
        label: "Saint-Joseph, QC",
        value: 2278,
    },
    {
        label: "Saint-Joseph-de-Beauce",
        value: 2280,
    },
    {
        label: "Saint-Joseph-de-la-Rive",
        value: 2282,
    },
    {
        label: "Saint-Joseph-de-Levis",
        value: 2281,
    },
    {
        label: "Saint-Joseph-de-Sorel",
        value: 2284,
    },
    {
        label: "Saint-Joseph-du-Lac",
        value: 2283,
    },
    {
        label: "Saint-Lambert",
        value: 1766,
    },
    {
        label: "Saint-Lazare",
        value: 2115,
    },
    {
        label: "Saint-LÃ©on",
        value: 2290,
    },
    {
        label: "Saint-LÃ©onard, QC",
        value: 2292,
    },
    {
        label: "Saint-LÃ©onard-d'Aston",
        value: 2294,
    },
    {
        label: "Saint-Lin",
        value: 1767,
    },
    {
        label: "Saint-Louis-du-Ha!-Ha!",
        value: 1081,
    },
    {
        label: "Saint-Luc-de-Vincennes",
        value: 2300,
    },
    {
        label: "Saint-Ludger",
        value: 2302,
    },
    {
        label: "Saint-Marc sur Richelieu",
        value: 1779,
    },
    {
        label: "Saint-Marc-des-CarriÃ¨res",
        value: 2304,
    },
    {
        label: "Saint-Mathias",
        value: 2303,
    },
    {
        label: "Saint-Mathieu",
        value: 2119,
    },
    {
        label: "Saint-Mathieu-de-Beloeil",
        value: 2305,
    },
    {
        label: "Saint-Mathieu-du-Parc",
        value: 2301,
    },
    {
        label: "Saint-Michel-des-Saints",
        value: 1591,
    },
    {
        label: "Saint-Patrice-de-Beaurivage",
        value: 2318,
    },
    {
        label: "Saint-Paul",
        value: 1139,
    },
    {
        label: "Saint-Phillipe",
        value: 2117,
    },
    {
        label: "Saint-Pie-de-Bagot",
        value: 2323,
    },
    {
        label: "Saint-Pierre-les-Becquets",
        value: 1593,
    },
    {
        label: "Saint-Rock-sur-Richelieu",
        value: 2335,
    },
    {
        label: "Saint-Romuald, QC",
        value: 1015,
    },
    {
        label: "Saint-Romuald-d'Etchemin",
        value: 2340,
    },
    {
        label: "Saint-Sauveur-des-Monts",
        value: 2342,
    },
    {
        label: "Saint-Sebastien",
        value: 2344,
    },
    {
        label: "Saint-Sulpice",
        value: 2349,
    },
    {
        label: "Saint-SylvÃ¨re",
        value: 2350,
    },
    {
        label: "Saint-ThÃ©odore-d'Acton",
        value: 2353,
    },
    {
        label: "Saint-Thomas",
        value: 1141,
    },
    {
        label: "Saint-TimothÃ©e",
        value: 2358,
    },
    {
        label: "Saint-Urbain",
        value: 2365,
    },
    {
        label: "Saint-ValÃ©rien",
        value: 1594,
    },
    {
        label: "Saint-Vincent-de-Paul",
        value: 1768,
    },
    {
        label: "Saint-ZÃ©non",
        value: 1595,
    },
    {
        label: "Salaberry-de-Valleyfield",
        value: 2484,
    },
    {
        label: "Saules",
        value: 2111,
    },
    {
        label: "Sault-au-Mouton",
        value: 2116,
    },
    {
        label: "Sawyerville",
        value: 2118,
    },
    {
        label: "Sayabec",
        value: 2120,
    },
    {
        label: "Schefferville",
        value: 2122,
    },
    {
        label: "Scotstown",
        value: 2124,
    },
    {
        label: "Senneterre",
        value: 2126,
    },
    {
        label: "Senneville",
        value: 1764,
    },
    {
        label: "Sept Iles",
        value: 2130,
    },
    {
        label: "Shawbridge",
        value: 2132,
    },
    {
        label: "Shawinigan",
        value: 2134,
    },
    {
        label: "Shawinigan Sud",
        value: 2136,
    },
    {
        label: "Shawinigan-Nord",
        value: 2135,
    },
    {
        label: "Shawville",
        value: 2138,
    },
    {
        label: "Shefford",
        value: 1131,
    },
    {
        label: "Sherbrooke, QC",
        value: 2140,
    },
    {
        label: "Sherrington",
        value: 2141,
    },
    {
        label: "Sillery",
        value: 2142,
    },
    {
        label: "Snowdon",
        value: 1133,
    },
    {
        label: "Sorel",
        value: 2144,
    },
    {
        label: "St-Adolphe-d'How",
        value: 2145,
    },
    {
        label: "St-Adrien de Ham",
        value: 2147,
    },
    {
        label: "St-Agapitville",
        value: 2146,
    },
    {
        label: "St-Alban",
        value: 2148,
    },
    {
        label: "St-Albert",
        value: 2149,
    },
    {
        label: "St-Alexandre",
        value: 2150,
    },
    {
        label: "St-Alexis",
        value: 2152,
    },
    {
        label: "St-Amable",
        value: 2153,
    },
    {
        label: "St-Ambroise",
        value: 2154,
    },
    {
        label: "Stanbridge East",
        value: 2375,
    },
    {
        label: "Stanbridge Stat",
        value: 2377,
    },
    {
        label: "St-Andre Est",
        value: 2160,
    },
    {
        label: "Stanhope",
        value: 2433,
    },
    {
        label: "St-Anicet",
        value: 2161,
    },
    {
        label: "St-Anselme",
        value: 2162,
    },
    {
        label: "Stanstead Plain",
        value: 2376,
    },
    {
        label: "St-Antoine",
        value: 2164,
    },
    {
        label: "St-Augustin",
        value: 2165,
    },
    {
        label: "St-Augustin-de-De",
        value: 2169,
    },
    {
        label: "St-Barthelemy",
        value: 2167,
    },
    {
        label: "St-Basile Sud",
        value: 2168,
    },
    {
        label: "St-Bernard",
        value: 2170,
    },
    {
        label: "St-Blaise",
        value: 2171,
    },
    {
        label: "St-Boniface",
        value: 2173,
    },
    {
        label: "St-Bruno",
        value: 2174,
    },
    {
        label: "St-Calixte",
        value: 2178,
    },
    {
        label: "St-Casimir",
        value: 2180,
    },
    {
        label: "St-Casimir Est",
        value: 2182,
    },
    {
        label: "St-Cesaire",
        value: 2184,
    },
    {
        label: "St-Charles",
        value: 2186,
    },
    {
        label: "St-Chrysostome",
        value: 2192,
    },
    {
        label: "St-Cleophas",
        value: 2193,
    },
    {
        label: "St-Clet",
        value: 2194,
    },
    {
        label: "St-Colomban",
        value: 2195,
    },
    {
        label: "St-Constant",
        value: 2113,
    },
    {
        label: "St-Cyprien",
        value: 2197,
    },
    {
        label: "St-Cyrille",
        value: 2198,
    },
    {
        label: "St-Damase",
        value: 2200,
    },
    {
        label: "St-Damien-de-Bra",
        value: 2201,
    },
    {
        label: "St-Denis",
        value: 2204,
    },
    {
        label: "St-Denis-de-Brom.",
        value: 1067,
    },
    {
        label: "St-Dominique",
        value: 2206,
    },
    {
        label: "St-Donat",
        value: 2203,
    },
    {
        label: "Ste-Adele",
        value: 2379,
    },
    {
        label: "Ste-Agathe",
        value: 2378,
    },
    {
        label: "Ste-Agathe Monts",
        value: 2380,
    },
    {
        label: "Ste-Agathe Sud",
        value: 2382,
    },
    {
        label: "Ste-Angele Merici",
        value: 2384,
    },
    {
        label: "Ste-Angele-de-Lav",
        value: 2383,
    },
    {
        label: "Ste-Anne du Lac",
        value: 2392,
    },
    {
        label: "Ste-Anne Monts",
        value: 2390,
    },
    {
        label: "Ste-Anne Plaines",
        value: 2397,
    },
    {
        label: "Ste-Anne-de-la-Pe",
        value: 2387,
    },
    {
        label: "Ste-Anne-de-la-Ro",
        value: 2388,
    },
    {
        label: "Ste-Anne-des-Lacs",
        value: 1143,
    },
    {
        label: "Ste-Anne-de-Sorel",
        value: 2389,
    },
    {
        label: "Ste-Brigit.-Laval",
        value: 1080,
    },
    {
        label: "Ste-Brigitte",
        value: 2403,
    },
    {
        label: "Ste-Christine",
        value: 2406,
    },
    {
        label: "Ste-Clothide Hort",
        value: 2398,
    },
    {
        label: "Ste-Croix",
        value: 2400,
    },
    {
        label: "St-Edmond",
        value: 2205,
    },
    {
        label: "St-Edouard",
        value: 2207,
    },
    {
        label: "Ste-Elizabeth",
        value: 2407,
    },
    {
        label: "Ste-Francoise Lac",
        value: 2222,
    },
    {
        label: "Ste-Gertrude",
        value: 2409,
    },
    {
        label: "Ste-Henedine",
        value: 2413,
    },
    {
        label: "Ste-Julienne",
        value: 2414,
    },
    {
        label: "St-Elzear",
        value: 2208,
    },
    {
        label: "Ste-Madeleine",
        value: 2412,
    },
    {
        label: "Ste-Mar.Lac-Mass.",
        value: 1083,
    },
    {
        label: "Ste-Marguerite",
        value: 2415,
    },
    {
        label: "Ste-Marguerite-de",
        value: 2421,
    },
    {
        label: "Ste-Marie",
        value: 2416,
    },
    {
        label: "Ste-Marthe",
        value: 2418,
    },
    {
        label: "Ste-Martine",
        value: 2417,
    },
    {
        label: "St-Emile",
        value: 2210,
    },
    {
        label: "Ste-Monique",
        value: 2420,
    },
    {
        label: "Ste-Prudentienne",
        value: 2422,
    },
    {
        label: "Ste-Rosalie",
        value: 2424,
    },
    {
        label: "Ste-Rose",
        value: 2425,
    },
    {
        label: "Ste-Rose-Watford",
        value: 1085,
    },
    {
        label: "Ste-Sabine",
        value: 2427,
    },
    {
        label: "Ste-Sophie-de-Meg",
        value: 2429,
    },
    {
        label: "Ste-Therese",
        value: 2430,
    },
    {
        label: "St-Eugene",
        value: 2213,
    },
    {
        label: "St-Eustache",
        value: 2214,
    },
    {
        label: "Ste-Veronique",
        value: 2431,
    },
    {
        label: "St-Felicien",
        value: 2216,
    },
    {
        label: "St-Ferdinand",
        value: 2219,
    },
    {
        label: "St-Flavien",
        value: 2220,
    },
    {
        label: "St-Fulgence",
        value: 2224,
    },
    {
        label: "St-Gabriel",
        value: 2226,
    },
    {
        label: "St-Gabriel-Brand.",
        value: 1071,
    },
    {
        label: "St-Georges",
        value: 2230,
    },
    {
        label: "St-Gerard",
        value: 2238,
    },
    {
        label: "St-Gregoire-de-Ni",
        value: 2245,
    },
    {
        label: "St-Guillaume",
        value: 2246,
    },
    {
        label: "St-Henri",
        value: 2248,
    },
    {
        label: "St-Hippolyte",
        value: 2259,
    },
    {
        label: "St-Hubert",
        value: 2254,
    },
    {
        label: "St-Hughes",
        value: 2256,
    },
    {
        label: "St-Hyacinthe",
        value: 2258,
    },
    {
        label: "St-Isidore",
        value: 2260,
    },
    {
        label: "St-Jacques",
        value: 2262,
    },
    {
        label: "St-Jacques de Mon",
        value: 2261,
    },
    {
        label: "St-Janvier",
        value: 2263,
    },
    {
        label: "St-Jean-Baptiste",
        value: 1600,
    },
    {
        label: "St-Jovite",
        value: 2286,
    },
    {
        label: "St-Julien",
        value: 2288,
    },
    {
        label: "St-Liboire",
        value: 2296,
    },
    {
        label: "St-Louis Terrebon",
        value: 2297,
    },
    {
        label: "St-Louis-de-Franc",
        value: 1013,
    },
    {
        label: "St-Luc",
        value: 2298,
    },
    {
        label: "St-Mathias-Riche.",
        value: 1073,
    },
    {
        label: "St-Michel",
        value: 2307,
    },
    {
        label: "St-Nicephore",
        value: 2309,
    },
    {
        label: "St-Nicholas",
        value: 2306,
    },
    {
        label: "St-Noel",
        value: 2308,
    },
    {
        label: "St-Norbert",
        value: 2311,
    },
    {
        label: "Stoke",
        value: 1592,
    },
    {
        label: "Stoneham",
        value: 2435,
    },
    {
        label: "St-Ours",
        value: 2310,
    },
    {
        label: "St-Pacome",
        value: 2312,
    },
    {
        label: "St-Pamphile",
        value: 2314,
    },
    {
        label: "St-Pascal",
        value: 2316,
    },
    {
        label: "St-Paulin",
        value: 2320,
    },
    {
        label: "St-Pie",
        value: 2322,
    },
    {
        label: "St-Pierre",
        value: 2324,
    },
    {
        label: "St-Pierre-Baptist",
        value: 1596,
    },
    {
        label: "St-Placide",
        value: 2326,
    },
    {
        label: "St-Polycarpe",
        value: 2328,
    },
    {
        label: "St-Prime",
        value: 2330,
    },
    {
        label: "St-Raphael",
        value: 2332,
    },
    {
        label: "Stratford, QC",
        value: 2437,
    },
    {
        label: "St-Raymond",
        value: 2334,
    },
    {
        label: "St-Redempteur",
        value: 2336,
    },
    {
        label: "St-Remi",
        value: 2338,
    },
    {
        label: "St-Robert",
        value: 2339,
    },
    {
        label: "St-Roch-Aulnaies",
        value: 1077,
    },
    {
        label: "St-Roch-de-L'Achi",
        value: 1075,
    },
    {
        label: "St-Romain",
        value: 2337,
    },
    {
        label: "St-Saurcur",
        value: 2341,
    },
    {
        label: "St-Sauveur",
        value: 2343,
    },
    {
        label: "St-Severin-de-Pro",
        value: 2345,
    },
    {
        label: "St-Simeon",
        value: 2346,
    },
    {
        label: "St-Simon-de-Bagot",
        value: 1031,
    },
    {
        label: "St-Stanislaus",
        value: 2348,
    },
    {
        label: "St-Sylvestre",
        value: 2352,
    },
    {
        label: "St-Thecle",
        value: 2354,
    },
    {
        label: "St-Theophile",
        value: 2356,
    },
    {
        label: "St-Tite",
        value: 2360,
    },
    {
        label: "St-Ubald",
        value: 2362,
    },
    {
        label: "Stukely-Sud",
        value: 2434,
    },
    {
        label: "St-Ulric",
        value: 2364,
    },
    {
        label: "St-Valerien-Milt.",
        value: 1079,
    },
    {
        label: "St-Vallier",
        value: 2366,
    },
    {
        label: "St-Victor",
        value: 2368,
    },
    {
        label: "St-Wendeslas",
        value: 2370,
    },
    {
        label: "St-Zacharie",
        value: 2372,
    },
    {
        label: "St-Zephirin",
        value: 2373,
    },
    {
        label: "St-Zotique",
        value: 2374,
    },
    {
        label: "Sutton, QC",
        value: 2436,
    },
    {
        label: "Tadoussac",
        value: 2440,
    },
    {
        label: "Temiscaming",
        value: 2442,
    },
    {
        label: "Templeton",
        value: 2444,
    },
    {
        label: "Terrasse-Vaudreuil",
        value: 2445,
    },
    {
        label: "Terrebonne",
        value: 2446,
    },
    {
        label: "Thetford Mines, QC",
        value: 2448,
    },
    {
        label: "Thurso",
        value: 2450,
    },
    {
        label: "Tingwick",
        value: 1121,
    },
    {
        label: "Tracy, QC",
        value: 2452,
    },
    {
        label: "Tring-Jonction",
        value: 2454,
    },
    {
        label: "Trois-Pistoles",
        value: 2456,
    },
    {
        label: "Trois-RiviÃ¨res",
        value: 2458,
    },
    {
        label: "Upton",
        value: 2460,
    },
    {
        label: "Val-Barette",
        value: 2470,
    },
    {
        label: "Val-Belair",
        value: 1781,
    },
    {
        label: "Val-Brillant",
        value: 2472,
    },
    {
        label: "Valcartier",
        value: 2479,
    },
    {
        label: "Valcourt",
        value: 2480,
    },
    {
        label: "Val-David",
        value: 2476,
    },
    {
        label: "Val-des-Bois",
        value: 1087,
    },
    {
        label: "Val-des-Monts, QC",
        value: 1017,
    },
    {
        label: "Val-d'Or",
        value: 2474,
    },
    {
        label: "VallÃ©e-Jonction",
        value: 2482,
    },
    {
        label: "Val-Morin",
        value: 2477,
    },
    {
        label: "Valois",
        value: 1780,
    },
    {
        label: "Val-Racine",
        value: 1089,
    },
    {
        label: "Val-Saint-Michel",
        value: 2478,
    },
    {
        label: "Vanier, QC",
        value: 2044,
    },
    {
        label: "Varennes",
        value: 2488,
    },
    {
        label: "Vaudreuil",
        value: 2490,
    },
    {
        label: "Vaudreuil-Dorion",
        value: 2489,
    },
    {
        label: "Vaudreuil-sur-la-Lac",
        value: 2491,
    },
    {
        label: "VendÃ©e",
        value: 2493,
    },
    {
        label: "Venise-en-QuÃ©bec",
        value: 2494,
    },
    {
        label: "VerchÃ¨res",
        value: 2492,
    },
    {
        label: "Verdun",
        value: 1782,
    },
    {
        label: "Victoriaville, QC",
        value: 2496,
    },
    {
        label: "Ville de L'Ãle Perrot",
        value: 1786,
    },
    {
        label: "Ville Emard",
        value: 1155,
    },
    {
        label: "Ville LeMoyne",
        value: 2499,
    },
    {
        label: "Ville Saint-Laurent",
        value: 1790,
    },
    {
        label: "Ville Saint-Pierre",
        value: 1792,
    },
    {
        label: "Ville-Marie",
        value: 2498,
    },
    {
        label: "Villeneuve",
        value: 2500,
    },
    {
        label: "Vimont",
        value: 1800,
    },
    {
        label: "Wakefield, QC",
        value: 2510,
    },
    {
        label: "Warden",
        value: 2512,
    },
    {
        label: "Warwick",
        value: 2514,
    },
    {
        label: "Waterloo, QC",
        value: 2516,
    },
    {
        label: "Waterville, QC",
        value: 2518,
    },
    {
        label: "Weedon-Centre",
        value: 2520,
    },
    {
        label: "Wentworth-Nord",
        value: 1149,
    },
    {
        label: "Westmount",
        value: 1802,
    },
    {
        label: "Wickham",
        value: 2524,
    },
    {
        label: "Windmill Point",
        value: 1804,
    },
    {
        label: "Windsor, QC",
        value: 2526,
    },
    {
        label: "Wootenville",
        value: 2528,
    },
    {
        label: "Wotton",
        value: 2532,
    },
    {
        label: "Yamachiche",
        value: 2540,
    },
    {
        label: "Yamaska",
        value: 2542,
    },
    {
        label: "Yamaska-Est",
        value: 2544,
    },
];
